import { Clear, Search } from "@mui/icons-material";
import { IconButton, InputAdornment, Paper, TextField } from "@mui/material";
import { memo, useCallback } from "react";

type SearchBarProps = {
  searchQuery: string;
  setSearchQuery: React.Dispatch<React.SetStateAction<string>>;
  placeholder?: string;
  "data-testid"?: string;
};

const SearchBar = memo(
  ({
    searchQuery,
    setSearchQuery,
    placeholder = "Search",
    "data-testid": dataTestId,
  }: SearchBarProps) => {
    const handleInputChange = useCallback(
      (e: React.ChangeEvent<HTMLInputElement>) => {
        setSearchQuery(e.target.value);
      },
      [setSearchQuery],
    );

    const handleClear = useCallback(() => {
      setSearchQuery("");
    }, [setSearchQuery]);

    return (
      <Paper elevation={0} sx={{ mb: 1 }} data-testid={dataTestId}>
        <TextField
          id="outlined-basic"
          variant="outlined"
          size="small"
          fullWidth
          value={searchQuery}
          onChange={handleInputChange}
          placeholder={placeholder}
          data-attr="datasets:input:search-datasets"
          inputProps={{
            "data-testid": dataTestId ? `${dataTestId}-input` : undefined,
          }}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start" sx={{ color: "black", mr: 0.4 }}>
                <Search fontSize="small" />
              </InputAdornment>
            ),
            endAdornment: searchQuery && (
              <InputAdornment position="end">
                <IconButton
                  aria-label="clear search"
                  onClick={handleClear}
                  data-attr="datasets:btn:clear-search"
                >
                  <Clear fontSize="small" />
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
      </Paper>
    );
  },
);

export default SearchBar;
